export function isMasterByEmail(email?: string | null): boolean {
  const MASTER_EMAIL = (import.meta.env.VITE_MASTER_EMAIL as string) || 'rgo.mendes@gmail.com'
  return (email || '').toLowerCase() === MASTER_EMAIL.toLowerCase()
}

export type AppRole = 'master' | 'member' | 'afiliado' | 'vip-100' | 'vip-50' | ''

export function normalizeRole(role?: string | null): AppRole {
  const r = String(role || '').trim().toLowerCase()
  if (r === 'master') return 'master'
  if (r === 'afiliado' || r === 'affiliate') return 'afiliado'
  if (r === 'member') return 'member'
  if (r === 'vip-100' || r === 'vip100' || r === 'vip-50' || r === 'vip50') return 'member'
  return ''
}
